import type RootStore from "../../../stores/RootStore";
import type ServiceStore from "../../../stores/ServiceStore";
import { RouteType } from "../../../types/RouteType";

const productionOutlookRoute: RouteType = {
  name: "ProductionOutlook",
  path: "/production/outlook",
  title: "Production Outlook",
  layout: "/app",
  group: "Production",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  viewportCard: {
    header: {
      component: () => import("./ProductionOutlook.Header"),
      title: "Production Outlook",
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./ProductionOutlook"),
      grayBackground: false,
    },
  },
  onEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const projectsStore = rootStore.projectsStore as ServiceStore;
    if (projectsStore?.find) await projectsStore.find();
  },
};

export default productionOutlookRoute;
